import { ProductData } from 'utils/types';

const getIsLastInRow = (index: number, subProducts: ProductData[]) =>
  index + 1 === subProducts.length || (index + 1) % 4 === 0;

const splitSubProductsArray = (
  array: ProductData[],
  chunkSize = 8,
): ProductData[][] => {
  let result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

export const babaUtils = {
  getIsLastInRow,
  splitSubProductsArray,
};
